import React from 'react';

const TrackIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M19.5 12.5C19.5 11.12 20.62 10 22 10V9C22 5 21 4 17 4H7C3 4 2 5 2 9V9.5C3.38 9.5 4.5 10.62 4.5 12C4.5 13.38 3.38 14.5 2 14.5V15C2 19 3 20 7 20H17C21 20 22 19 22 15C20.62 15 19.5 13.88 19.5 12.5Z"
            stroke="#292D32"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10 4L10 20"
            stroke="#292D32"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="5 5"
        />
    </svg>
);

export default TrackIcon;
